import { render } from "./ModalAdicionarTipoAcomodacao.vue?vue&type=template&id=8859ec10"
import script from "./ModalAdicionarTipoAcomodacao.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarTipoAcomodacao.vue?vue&type=script&lang=js"

import "./ModalAdicionarTipoAcomodacao.vue?vue&type=style&index=0&id=8859ec10&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__